import {observer} from "mobx-react";
import {HelpIcon} from "../../../components";
import {ReactSelectLocationSelector} from "../../../services/locations/ReactSelectLocationSelector";
import {DropdownItem, DropdownMenu, DropdownToggle, UncontrolledDropdown} from "reactstrap";
import PropTypes from "prop-types";
import * as React from "react";
import {useContext} from "react";
import {useNavPreferences} from "../../../uiMigration/navPreferences";
import "./location-dropdown-settings.css"
import { PageFiltersContext } from './PageFilters';

export const AppLocationFilter = observer(({
                                      isSingleAccountOnly,
                                      shouldNotIncludeAccounts
                                    }) => {
  const pageFiltersContext = useContext(PageFiltersContext);
  const prefs = useNavPreferences();
  return <form className={`form-inline d-flex ${pageFiltersContext.isHorizontal ? "mr-2 my-lg-2" : ""} order-lg-1 location-selector ${prefs.condensedAccountLinks ? "ml-1" : "ml-auto"}`} role="search">
    <div className={`form-group d-flex flex-row mb-0 align-items-center ${pageFiltersContext.isHorizontal ? "" : "w-100"}`}>
      {
        pageFiltersContext.isHorizontal && <label className="control-label d-flex align-items-center m-0 mr-2">
          <span className="d-flex align-self-center">Location</span>
          <HelpIcon
            className="d-flex"
            message="Enter Group Name, Business Name, Street, or City."
            placement="bottom"
          />
        </label>
      }
      {
        <div className={`location-search-box react-select mb-0 ${pageFiltersContext.isHorizontal ? "" : "w-100"}`}>
          <ReactSelectLocationSelector isSingleAccountOnly={isSingleAccountOnly} shouldNotIncludeAccounts={shouldNotIncludeAccounts} />
        </div>
      }
      {
        pageFiltersContext.isHorizontal && (!prefs.hideManageGroups || !prefs.hideManageLocations) && <span>
          <UncontrolledDropdown className="location-dropdown-settings" direction="left">
            <DropdownToggle tag="span" className="location-dropdown-settings__toggle">
              <i className="location-dropdown-settings__icon fas fa-cog fa-lg"/>
            </DropdownToggle>
            <DropdownMenu>
              {!prefs.hideManageLocations && <DropdownItem tag="a" href="#/admin/v2/locations">Locations & Competitors</DropdownItem>}
              {!prefs.hideManageGroups && <DropdownItem tag="a" href="#/admin/v2/groups">Manage Groups</DropdownItem>}
            </DropdownMenu>
          </UncontrolledDropdown>
          </span>
      }
    </div>
  </form>
})

AppLocationFilter.propTypes = {
  isSingleAccountOnly: PropTypes.bool,
  shouldNotIncludeAccounts: PropTypes.bool,
}
